import React, { useState } from "react";

interface Unidade {
  id: number;
  nome: string;
}

interface SelectUnidadeModalProps {
  unidades: Unidade[];
  onConfirm: (unidade: Unidade) => void;
}

export const SelectUnidadeModal: React.FC<SelectUnidadeModalProps> = ({ unidades, onConfirm }) => {
  const [selected, setSelected] = useState<Unidade>(unidades[0]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50">
      <div className="bg-zinc-900 p-6 rounded shadow-lg min-w-[300px] border border-zinc-700">
        <h2 className="mb-4 text-lg font-bold text-zinc-100">Selecione a Unidade</h2>
        <select
          className="border border-zinc-700 bg-zinc-800 text-zinc-100 p-2 w-full mb-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-600"
          value={selected.id}
          onChange={e => {
            const unidade = unidades.find(u => u.id === Number(e.target.value));
            if (unidade) setSelected(unidade);
          }}
        >
          {unidades.map(u => (
            <option key={u.id} value={u.id}>{u.nome}</option>
          ))}
        </select>
        <button
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded w-full font-semibold transition-colors"
          onClick={() => onConfirm(selected)}
        >
          Confirmar
        </button>
      </div>
    </div>
  );
}; 